import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.595 8.445c.328.276.478.712.37 1.135a1.16 1.16 0 01-.872.84 1.2 1.2 0 01-1.14-.344c-.749-.705-1.853-.97-2.877-.678-.803.23-1.441.77-1.78 1.46h3.294c.626 0 1.177.487 1.177 1.142 0 .655-.551 1.143-1.177 1.143H9.296c.339.689.977 1.229 1.78 1.458 1.029.294 2.14.025 2.889-.688l.014-.014.015-.012a1.203 1.203 0 011.578.06 1.12 1.12 0 01.063 1.569l-.013.014-.014.014c-1.403 1.333-3.47 1.794-5.34 1.203-1.751-.553-3.07-1.946-3.469-3.665C6.345 12.932 6 12.518 6 12c0-.518.345-.932.8-1.082.398-1.72 1.717-3.112 3.468-3.665 1.865-.589 3.925-.133 5.327 1.192z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
